import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from 'Components/App/App';
import reportWebVitals from './reportWebVitals';
import { FlowProvider } from 'flow-react';

const container = document.getElementById('root');
const root = createRoot(container);
// const wsurl = "http://localhost:3000/api/initws";
// const wsurl = "https://vifogra.flowcenter.de/flow2/api/initws";
const wsurl = "https://vifogra.de/flow2/api/initws";
// const wsurl = "https://vifogra.de/flow2/api/initws";

root.render(
  <React.StrictMode>
    <FlowProvider apiurl={wsurl} config={{pingtime: 2,throwonfail: false}}>
      <App />
    </FlowProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
